export default "__VITE_ASSET__BmszHVLp__"